var getTableTheme = theme => {
  return {
    colors: {
      headerBackground: {
        hover: theme.colors.ultraViolets[20]
      },
      rowText: {
        initial: theme.colors.greys[100]
      },
      rowBorder: {
        initial: theme.colors.greys[20]
      },
      rowBackground: {
        hover: theme.colors.greys[10]
      },
      paginationButtonIcon: {
        disabled: theme.colors.greys[40],
        initial: theme.colors.greys[100]
      },
      paginationText: {
        initial: theme.colors.greys[80]
      }
    }
  };
};
export { getTableTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
